import React from 'react';
import PropTypes from 'prop-types';

import { getProportion } from 'utilities/index';

const SamplesSpecificationsTableComponent = props =>
  <table className="main-table main-table--no-first-param">
    <colgroup>
      <col className="bg-grey-150" />
    </colgroup>

    <thead>
      <tr>
        <th />
        <th className="text-right">Original Dataset</th>
        <th className="text-right">Selected Sample</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td className="font-13 font-700">
          Count of {props.parameterName} = {`'${props.parameterLevel}'`}
        </td>

        <td className="text-right">{props.levelAmount.original}</td>
        <td className="text-right">{props.levelAmount.bootstrapped}</td>
      </tr>

      <tr>
        <td className="font-13 font-700">
          Total Number of Observations
        </td>

        <td className="text-right">{props.totalAmount.original}</td>
        <td className="text-right">{props.totalAmount.bootstrapped}</td>
      </tr>

      <tr>
        <td className="font-13 font-700">Proportion</td>
        <td className="text-right">
          {getProportion(props.levelAmount.original, props.totalAmount.original)}
        </td>

        <td className="text-right">
          {getProportion(props.levelAmount.bootstrapped, props.totalAmount.bootstrapped)}
        </td>
      </tr>
    </tbody>
  </table>;

SamplesSpecificationsTableComponent.propTypes = {
  levelAmount: PropTypes.object.isRequired,
  totalAmount: PropTypes.object.isRequired,

  parameterLevel: PropTypes.string.isRequired,
  parameterName: PropTypes.string.isRequired
};

export default SamplesSpecificationsTableComponent;
